import { Component, OnInit } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { ApplicationLogService, EmailTrackResponce, LazyLoadingResponse } from 'src/app/Services/applicationlogs.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';

@Component({
    selector: 'app-email-track-log',
    templateUrl: './email-track-log.component.html',
    styleUrls: ['./email-track-log.component.css'],
    standalone: false
})
export class EmailTrackLogComponent implements OnInit {
  public authConfig: AuthConfig = {};
  public emailTrackloading: boolean = false;
  public lazyEmailTrackLogs: EmailTrackResponce[] = [];
  public rows: number = 20;
  public totalRecords!: number;

  constructor(private authService: AuthService,
    private applicationLogService: ApplicationLogService) {

  }
  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      // this.getEmailTrack();
      this.getlazyEmailTrackLogs({ first: 0, rows: this.rows, sortField: '1' });
    }
  }

  public getlazyEmailTrackLogs(event: TableLazyLoadEvent) {
    this.emailTrackloading = true;
    event.sortField = '1';
    // Adjust the API call to include lazyLoadParams
    this.applicationLogService.getEmailTrackLogs(event).subscribe((lazyLogs: LazyLoadingResponse<EmailTrackResponce>) => {
      if (lazyLogs && lazyLogs.data) {
        this.lazyEmailTrackLogs = lazyLogs.data;
        this.totalRecords = lazyLogs.totalRecords;
        this.emailTrackloading = false;
      } else {
        console.error('Error: No data received');
      }     
    }, (error) => {
      console.error('Error fetching Application logs:', error);
      this.emailTrackloading = false;
    });
  }

  public getRowStyle(log: any): string {
    if (log.Level === 'Error') {
      return 'text-danger';
    }
    return '';
  }  

  public refreshLogs(): void {
    this.getlazyEmailTrackLogs({ first: 0, rows: this.rows, sortField: '1' });
  }
}
